import request from '@/utils/request'

// 网站浏览首页
export function appInit(data) {
  return request({
    url: 'app_init',
    method: 'get',
	params: data
  })
}

// 网站案例浏览
export function projectView(data) {
  return request({
    url: 'project_view',
    method: 'get',
	params: data
  })
}
// 网站商家浏览
export function merchantView(data) {
  return request({
    url: 'merchant_view',
    method: 'get',
	params: data
  })
}

// 板块分类列表
export function getCategoryList() {
  return request({
    url: 'category',
    method: 'get',
  })
}

// 获取专栏列表
export function getCateCompanyList() {
  return request({
    url: 'catecompany',
    method: 'get',
  })
}


// 获取推荐项目列表
export function getRecommendList(data) {
  return request({
    url: 'project/recommend',
    method: 'get',
	params: data
  })
}


// 获取分类案例列表
export function getCateProjectList(data) {
  return request({
    url: 'project/cate_list',
    method: 'get',
	params: data
  })
}

// 获取案例详情
export function getProjectInfo(data) {
  return request({
    url: 'project/get_info',
    method: 'get',
	params: data
  })
}

// 获取展厅列表
export function getShowList(data) {
  return request({
    url: 'show/show_list',
    method: 'get',
	params: data
  })
}


// 获取会展列表
export function getExhibitionList(data) {
  return request({
    url: 'exhibition/list',
    method: 'get',
	params: data
  })
}


// 获取分类案例列表
export function getProjectList(data) {
  return request({
    url: 'project/search_list',
    method: 'get',
	params: data
  })
}

// 获取分类商家列表
export function getMerchantList(data) {
  return request({
    url: 'merchant/search_list',
    method: 'get',
	params: data
  })
}


// 获取产品列表
export function getProductList(data) {
  return request({
    url: 'product/product_list',
    method: 'get',
	params: data
  })
}

// 用户登录
export function login(data) {
  return request({
    url: 'login',
    method: 'get',
	params: data
  })
}

// 获取验证码
export function verifyCode(data) {
  return request({
    url: 'verifyCode',
    method: 'get',
	params: data
  })
}

// 获取案例中所有产品
export function getProjectProductList(data) {
  return request({
    url: 'project/product_list',
    method: 'get',
	params: data
  })
}

// 获取案例的评论
export function getProjectCommentList(data) {
  return request({
    url: 'project/comment',
    method: 'get',
	params: data
  })
}

// 获取商家详情
export function getMerchantInfo(data) {
  return request({
    url: 'merchant/get_info',
    method: 'get',
	params: data
  })
}

// 获取商家产品列表
export function getMerchantProductList(data) {
  return request({
    url: 'merchant/product_list',
    method: 'get',
	params: data
  })
}
// 商家关联案例列表（包括自己发布以及引用我商品的案例的列表）
export function getMerchantProjectList(data) {
  return request({
    url: 'merchant/project_list',
    method: 'get',
	params: data
  })
}
// 获取商家所发布的展厅列表
export function getMerchantShowList(data) {
  return request({
    url: 'merchant/show_list',
    method: 'get',
	params: data
  })
}

// 获取产品详情
export function getProductInfo(data) {
  return request({
    url: 'product/get_info',
    method: 'get',
	params: data
  })
}

// 获取产品的评论
export function getProductCommentList(data) {
  return request({
    url: 'product/comment',
    method: 'get',
	params: data
  })
}


// 获取展厅详情
export function getShowInfo(data) {
  return request({
    url: 'show/get_info',
    method: 'get',
	params: data
  })
}

// 获取会展详情
export function getExhibitionInfo(data) {
  return request({
    url: 'exhibition/get_info',
    method: 'get',
	params: data
  })
}

// 获取展位列表
export function getBoothList(data) {
  return request({
    url: 'exhibition/get_booth_list',
    method: 'get',
	params: data
  })
}


// 案例点赞
export function LikeAdd(data) {
  return request({
    url: 'project/like_add',
    method: 'post',
	params: data
  })
}
// 案例取消点赞
export function LikeDel(data) {
  return request({
    url: 'project/like_del',
    method: 'post',
	params: data
  })
}

// 产品点赞
export function ProductLikeAdd(data) {
  return request({
    url: 'product/like_add',
    method: 'post',
	params: data
  })
}
// 产品取消点赞
export function ProductLikeDel(data) {
  return request({
    url: 'product/like_del',
    method: 'post',
	params: data
  })
}

// 展厅点赞
export function ShowLikeAdd(data) {
  return request({
    url: 'show/like_del',
    method: 'post',
	params: data
  })
}
// 展厅取消点赞
export function ShowLikeDel(data) {
  return request({
    url: 'show/like_del',
    method: 'post',
	params: data
  })
}

// 填写认证申请信息
export function userApply(data) {
  return request({
    url: 'user/apply',
    method: 'post',
	data
  })
}

// 获取展厅评论
export function getShowCommentList(data) {
  return request({
    url: 'show/comment',
    method: 'get',
	params: data
  })
}

// 项目评论
export function ProjectCommentSave(data) {
  return request({
    url: 'project/comment/save',
    method: 'post',
	data
  })
}

// 产品评论
export function ProductCommentSave(data) {
  return request({
    url: 'product/comment/save',
    method: 'post',
	data
  })
}

// 展厅评论
export function ShowCommentSave(data) {
  return request({
    url: 'show/comment/save',
    method: 'post',
	data
  })
}

// 产品评论点赞
export function commentProductLikeAdd(data) {
  return request({
    url: 'product/comment/like_add',
    method: 'post',
	data
  })
}
// 产品评论取消点赞
export function commentProductLikeDel(data) {
  return request({
    url: 'product/comment/like_del',
    method: 'post',
	data
  })
}
// 案例评论点赞
export function commentLikeAdd(data) {
  return request({
    url: 'project/comment/like_add',
    method: 'post',
	data
  })
}
// 案例评论取消点赞
export function commentLikeDel(data) {
  return request({
    url: 'project/comment/like_del',
    method: 'post',
	data
  })
}
// 展厅评论点赞
export function commentShowLikeAdd(data) {
  return request({
    url: 'show/comment/like_add',
    method: 'post',
	data
  })
}
// 展厅评论取消点赞
export function commentShowLikeDel(data) {
  return request({
    url: 'show/comment/like_del',
    method: 'post',
	data
  })
}
// 退出登录
export function logout() {
  return request({
    url: 'logout',
    method: 'get',
  })
}

// 热门搜索关键字获取
export function hotKeyword(data) {
  return request({
    url: 'search/hot_keyword',
    method: 'get',
	params: data
  })
}

// 用户关键词搜索
export function UserSearchList(data) {
  return request({
    url: 'user_search_list',
    method: 'post',
	data
  })
}

// 添加收藏
export function CollectAdd(data) {
  return request({
    url: 'collect/collect_add',
    method: 'post',
	data
  })
}

// 取消收藏
export function CollectDel(data) {
  return request({
    url: 'collect/collect_del',
    method: 'post',
	data
  })
}


// 获取展位详情
export function getBooth(data) {
  return request({
    url: 'exhibition/get_booth',
    method: 'get',
	params:data
  })
}


export function getUserInfo() {
  return request({
    url: 'user',
    method: 'get',
  })
}
// 用戶案例列表
export function projectList(data) {
  return request({
    url: 'project/list',
    method: 'get',
	params:data
  })
}
// 用戶商品列表
export function productList(data) {
  return request({
    url: 'product/list',
    method: 'get',
	params:data
  })
}
// 用戶展厅列表
export function showList(data) {
  return request({
    url: 'show/list',
    method: 'get',
	params:data
  })
}

// 用户浏览记录
export function userVisit(data) {
  return request({
    url: 'user/visit',
    method: 'get',
	params:data
  })
}

// 收藏列表
export function collectUser(data) {
  return request({
    url: 'collect/collect_user',
    method: 'post',
	params:data
  })
}

// 我的案例评论列表
export function myProjectCommentList(data) {
  return request({
    url: 'project/my_comment_list',
    method: 'post',
	params:data
  })
}
// 我的展厅评论列表
export function myShowCommentList(data) {
  return request({
    url: 'show/my_comment_list',
    method: 'post',
	params:data
  })
}
// 我的产品评论列表
export function myProductCommentList(data) {
  return request({
    url: 'product/my_comment_list',
    method: 'post',
	params:data
  })
}


// 获取活动列表
export function getPromoList(data) {
  return request({
    url: 'promotions/promotions',
    method: 'get',
    params: data
  })
}

// 获取活动列表
export function getPromoInfo(data) {
  return request({
    url: 'promotions/get_info',
    method: 'get',
    params: data
  })
}

// 活动预约 
export function promoReserve(data) {
  return request({
    url: 'promotions/reserve',
    method: 'post',
    params: data
  })
}

// 活动感兴趣（点赞）
export function promoLike(data) {
  return request({
    url: 'promotions/like',
    method: 'post',
    params: data
  })
}

// 根据商家id获取活动
export function getMerPromList(data) {
  return request({
    url: 'promotions/merchant_promotions',
    method: 'get',
    params: data
  })
}



